<mat-form-field class="example-form-field hide" appearance="fill" [hidden]="!isVisible">
  <mat-label>{{ 'search.search' | translate }}</mat-label>
  <input #searchBar matInput type="text" [(ngModel)]="searchTerm">
  <button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="resetSearch()">
    <mat-icon>close</mat-icon>
  </button>
</mat-form-field>

<app-products #productComponent [products]="products"
              (onPageChanged)="handlePageChange($event)"
              (onProductSelected)="handleProductSelected($event)"
></app-products>
